import { orderConfigurationValuesTypes } from "../../types"
import { tooltipDescType } from "../../types/types"

export const tooltipDesc: tooltipDescType = {
    orderConfig: [
        {
            featureName: 'Tele Order',
            featureDesc: 'Redirects the user to place a tele order.'
        },
        {
            featureName: 'Remote Order',
            featureDesc: 'Sends order link to the outlet.'
        },
        {
            featureName: 'Visit Order',
            featureDesc: 'Place an order at the outlet.'
        }
    ],
    orderType: [
        {
            featureName: 'All Products',
            featureDesc: 'Order from entire catalogue.'
        },
        {
            featureName: 'One Click Order',
            featureDesc: 'Order with personalized recommendations.'
        },
        {
            featureName: 'Mandated Assortment',
            featureDesc: 'Order from mandated products only.'
        },
    ],
    catalogueSearchConfig: [
        {
            featureName: 'Search',
            featureDesc: 'Display search bar in catalogue.'
        },
        {
            featureName: 'QR Code Scanner',
            featureDesc: 'Display QR code scanner in catalogue.'
        },
        {
            featureName: 'Filter',
            featureDesc: 'Display product filters in catalogue.'
        }
    ],
    catalogueViewConfig: [
        {
            featureName: 'SKU Description Formatter',
            featureDesc: 'Font format of product name.'
        },
        {
            featureName: 'SKU Code Visibility',
            featureDesc: 'Visibility of product code.'
        },
        {
            featureName: 'PTR Label',
            featureDesc: 'Edit price to the retailer label.'
        },
        {
            featureName: 'MRP Label',
            featureDesc: 'Retail selling price label.'
        },
        {
            featureName: 'Scheme Label',
            featureDesc: 'Edit scheme label.'
        },
        {
            featureName: 'Unit Label',
            featureDesc: 'Edit unit label for UoM description.'
        },
        {
            featureName: 'Pack Size Visibility',
            featureDesc: 'Visibility of pack size.'
        }
    ],
    dummyProductImgUpload: [
        {
            featureName: 'Dummy Product Image Upload',
            featureDesc: 'Upload a default product image. Would be useful in absence of a product image.'
        }
    ],
    orderCalcAndCartConfig: [
        {
            featureName: 'Unit Labels',
            featureDesc: 'Edit labels for unit, case and other.'
        },
        {
            featureName: 'Order Calculation Type',
            featureDesc: 'Select type of order calculation to display.'
        },
        {
            featureName: 'Volume Label',
            featureDesc: 'Edit volume label to display.'
        },
        {
            featureName: 'Unit Conversion',
            featureDesc: 'Unit conversion type.'
        },
        {
            featureName: 'Amount Calculation',
            featureDesc: 'Amount calculation visibility.'
        }
    ],
    orderSummaryConfig: [
        {
            featureName: 'Scheme Calculation',
            featureDesc: 'Visibility of discount calculation.'
        },
        {
            featureName: 'Order Summary Remarks',
            featureDesc: 'Allow remarks while placing an order.'
        },
        {
            featureName: 'Order Summary Disclaimer',
            featureDesc: 'Disclaimer at order summary section.'
        },
        {
            featureName: 'Min Order Type',
            featureDesc: 'Minimum order unit type.'
        },
        {
            featureName: 'Min Order Value or Volume',
            featureDesc: 'Enter minimum order value or volume.'
        },
        {
            featureName: 'Display Min Order Limit',
            featureDesc: 'Display minimum order info.'
        },
        {
            featureName: 'Min Order Validation',
            featureDesc: 'Restrict order due to min order value.'
        },
        {
            featureName: 'Distributor Visibility',
            featureDesc: 'Visibility of Distributor/Supplier details.'
        },
        {
            featureName: 'Order OTP',
            featureDesc: 'Generate OTP to place an order.'
        }
    ],
    orderTrackingConfig: [
        {
            featureName: 'Order Tracking',
            featureDesc: 'Order tracking and its subfeatures.'
        },
    ],
    orderInvoiceConfig: [
        {
            featureName: 'Order Feedback',
            featureDesc: 'Allow feedback after placing an order.'
        },
        {
            featureName: 'Feedback Labels',
            featureDesc: 'Edit feedback labels.'
        },
        {
            featureName: 'Order Disclaimer',
            featureDesc: 'Disclaimer after placing an order.'
        },
    ],
    orderNotificationConfig: [
        {
            featureName: 'First Order',
            featureDesc: 'Pop up message after placing first order.'
        },
        {
            featureName: 'All Order Notification',
            featureDesc: 'Notification after placing order.'
        },
    ],
    editOrderConfig: [
        {
            featureName: 'Edit Order',
            featureDesc: 'Allow order quantity editing.'
        },
        {
            featureName: 'Edit and Add Order',
            featureDesc: 'Allow order quantity editing and adding products.'
        },
        {
            featureName: 'Order Approval',
            featureDesc: 'Allow options to Confirm or Reject an order.'
        },
    ],
    orderNumConfig: [
        {
            featureName: 'Series',
            featureDesc: 'Edit order number series.'
        },
        {
            featureName: 'Order series length',
            featureDesc: 'Edit order number length.'
        },
        {
            featureName: 'Prefix',
            featureDesc: 'Edit order number prefix.'
        },
        {
            featureName: 'Suffix',
            featureDesc: 'Edit order number suffix.'
        },
    ],
    stockAvailabilityConfig: [
        {
            featureName: 'Stock Visibility',
            featureDesc: 'Visibility of stock available.'
        },
        {
            featureName: 'Stock Validation',
            featureDesc: 'Restrict order based on stock quantity.'
        },
    ],
    orderLinkSharingConfig: [
        {
            featureName: 'SMS',
            featureDesc: 'Enable SMS link sharing for placing order.'
        },
        {
            featureName: 'FB',
            featureDesc: 'Enable FB link sharing for placing order.'
        },
        {
            featureName: 'Line',
            featureDesc: 'Enable Line link sharing for placing order.'
        },
        {
            featureName: 'WhatsApp',
            featureDesc: 'Enable WhatsApp link sharing for placing order.'
        }
    ]
}


export const defaultOrderTrackingSupportValues=[
    {
      "code": "0",
      "status": "PENDING",
      "mapping": "PENDING",
      "priority": "0"
    },
    {
      "code": "5",
      "status": "REJECTED",
      "mapping": "REJECTED",
      "priority": "0"
    },
    {
      "code": "3",
      "status": "CONFIRMED",
      "mapping": "CONFIRMED",
      "priority": "0"
    },
    {
      "code": "4",
      "status": "OUT FOR DELIVERY",
      "mapping": "OUT FOR DELIVERY",
      "priority": "0"
    },
    {
      "code": "6",
      "status": "DELIVERED",
      "mapping": "DELIVERED",
      "priority": "0"
    }
  ]

export const defaultInputValues:orderConfigurationValuesTypes ={
    orderNotReceivedReasons: {
        "name": "orderNotReceivedReasons",
        "type": "list",
        "value": [""],//empty string will be deleted at the time of saving
        "docUrl": "",
        "description": ".",
        "possibleVals": [

        ]
    },
    orderFulfillmentTime:{
        "name": "orderFulfillmentTime",
        "type": "number",
        "value": 0,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            "number"
        ]
    },
    buyInSets:{
        "name": "buyInSets",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },
    avoidRecommendationMerging:{
        "name": "avoidRecommendationMerging",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },

    editOrderTimeValidation:{
        "name": "editOrderTimeValidation",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },
    stockVisibility:{
        "name": "stockVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },

    orderSourceVisibility:{
        "name": "orderSourceVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },
    orderTermsAndConditionVisibility:{
        "name": "orderTermsAndConditionVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    calculateOnlyOnPac:{
        "name": "calculateOnlyOnPac",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },
    toUseSupplierFilterInProductsApi:{
        "name": "toUseSupplierFilterInProductsApi",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },
    offersTabVisibility:{
        "name": "offersTabVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    showMarginPercentage:{
        "name": "showMarginPercentage",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    retailerMarginVisibility:{
        "name": "retailerMarginVisibility",
        "type": "boolean",
        "value": true,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    showSupplierDropdown:{
        "name": "showSupplierDropdown",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    orderDSIdVisibility:{
        "name": "orderDSIdVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    showFreeProductLabel:{
        "name": "showFreeProductLabel",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    showExternalRecommendations:{
        "name": "showExternalRecommendations",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    amountCalculation:{
        "name": "amountCalculation",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    normalisedQtyVisibility:{
        "name": "normalisedQtyVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    orderTrackingInvoiceVisibility:{
        "name": "orderTrackingInvoiceVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    billingInformationVisibility:{
        "name": "billingInformationVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    pricingApi:{
        "name": "pricingApi",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    toUseSupplierFilterInApi:{
        "name": "toUseSupplierFilterInApi",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    defaultOrderUOM: {
        "name": "defaultOrderUOM",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals":  [
            "Case",
            "Piece",
            "Other"
          ]
    },

    salesRepOrderSourceLabel: {
        "name": "salesRepOrderSourceLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals":  [
            "string"
          ]
    },
    orderCheckoutDiscountLabel: {
        "name": "orderCheckoutDiscountLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals":  [
            "string"
          ]
    },
    appOrderSourceLabel: {
        "name": "appOrderSourceLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals":  [
            "string"
          ]
    },

    orderCheckoutDefaultUnitLabel: {
        "name": "orderCheckoutDefaultUnitLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals":  [
            "string"

          ]
    },
    orderCheckoutPtrLabel: {
        "name": "orderCheckoutPtrLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    orderCheckoutFinalAmountLabel: {
        "name": "orderCheckoutFinalAmountLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    missedItemBasket: {
        "name": "missedItemBasket",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    orderCheckoutUnitLabel: {
        "name": "orderCheckoutUnitLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    offersTabLabel: {
        "name": "offersTabLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    orderFulfillmentTimeMessage: {
        "name": "orderFulfillmentTimeMessage",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    orderCheckoutTotalAmountLabel: {
        "name": "orderCheckoutTotalAmountLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    orderCancellationDisclaimer: {
        "name": "orderCancellationDisclaimer",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    orderCancellationSummaryDisclaimer: {
        "name": "orderCancellationSummaryDisclaimer",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    maxAllowedDigitForOrder: {
        "name": "maxAllowedDigitForOrder",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    orderCancellationReasons: {
        "name": "orderCancellationReasons",
        "type": "list",
        "value": [""],//empty string will be deleted at time of saving
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Reasons for order cancellation. We'll restrict that 5 reasons can be added at max.",
        "possibleVals": []
    },
    orderInvoiceDisclaimer:{
    "name": "orderInvoiceDisclaimer",
    "type": "list",
    "value": [ ],
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "custom disclaimers in order feedback page",
    "possibleVals": [
      "string"
    ]
  },
    orderTaking:{
        "name": "orderTaking",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    orderPo:{
        "name": "orderPo",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "If you want to give option to upload Image on order Summary Page",
        "possibleVals": [
        true,
        false
        ]
    },
    editOrder:{
        "name": "editOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To allow edit order(Only quantity for already ordered skus can be changed. No new product can be added).",
        "possibleVals": [
        true,
        false
        ]
    },
    rejectOrder:{
        "name": "rejectOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To allow reject Order",
        "possibleVals": [
        true,
        false
        ]
    },
    deleteOrder:{
        "name": "deleteOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To allow delete order",
        "possibleVals": [
        true,
        false
        ]
    },
    persistentCartNavigationBar: {
        "name" : "persistentCartNavigationBar",
        "type": "boolean",
        "value": false,
        "possibleVals": [],
        "description": "to show persistent Cart Navigation Bar",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    },
    dmsSpecificOrderTrackingSummary: {
        "name" : "dmsSpecificOrderTrackingSummary",
        "type": "boolean",
        "value": false,
        "possibleVals": [],
        "description": "to show Dms Order Tracking Summary and billing details",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0"
    },
    orderTrackingInvoiceTabVisibilitySfa: {
        "name" : "orderTrackingInvoiceTabVisibilitySfa",
        "type": "boolean",
        "value": false,
        "possibleVals": [],
        "description": "to show Invoice tab in SFA",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0"
        },
    orderTrackingInvoiceTabVisibility: {
        "name" : "orderTrackingInvoiceTabVisibility",
        "type": "boolean",
        "value": false,
        "possibleVals": [],
        "description": "to show Invoice tab",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0"
    },
    orderCalculationType:{
        "name": "orderCalculationType",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Calculation is based on the type of the config : 1) value : order will be calculated and placed on the basis of total amount of the order. For ex : in unnati (ITC client) the value will be equal to the total amount in MRP .2) volume : order will be calculated and placed on the basis of total quantity . For ex : in marsBelgium the volume of the order will the total pieces of the order.",
        "possibleVals": [
            "value",
            "volume",
            "value and volume"
        ]
    },
    fullFilledByLabel:{
        "name": "fullFilledByLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "renders the label that comes from the config",
        "possibleVals": [
        "string"
        ]
    },
    saveOrder:{
        "name": "saveOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "For showing saveOrder button in Sellina on orderSummary page.",
        "possibleVals": [
        true,
        false
        ]
    },
    teleOrder:{
        "name": "teleOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Redirects the user to place a tele order.",
        "possibleVals": [
        true,
        false
        ]
    },
    onlineCart:{
        "name": "onlineCart",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Used only in bata for Using online Cart",
        "possibleVals": [
        true,
        false
        ]
    },
    visitOrder:{
        "name": "visitOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Place an order at the outlet.",
        "possibleVals": [
        true,
        false
        ]
    },
    remoteOrder:{
        "name": "remoteOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Sends order link to the outlet",
        "possibleVals": [
        true,
        false
        ]
    },
    minOrder:{
        "name": "minOrder",
        "type": "integer",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To enable multiple uom selection so that a user is able to add a product in both case quantity as well as piece quantity.",
        "possibleVals": []
    },
    minOrderType:{
        "name": "minOrderType",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Minimum order unit type.",
        "possibleVals": [
        "value",
        "qty",
        "volume"
        ]
    },
    minOrderVisibility:{
        "name": "minOrderVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Display minimum order info.",
        "possibleVals": [
        true,
        false
        ]
    },
    discountCouponVisibility:{
        "name": "discountCouponVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Display discount Coupon.",
        "possibleVals": [
        true,
        false
        ]
    },
    minOrderValidation:{
        "name": "minOrderValidation",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Restrict order due to min order value or volume",
        "possibleVals": [
        true,
        false
        ]
    },
    oneClickOrder:{
        "name": "oneClickOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Order with personalized recommendations",
        "possibleVals": [
        true,
        false
        ]
    },
    orderApproval:{
        "name": "orderApproval",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Allow options to Confirm or Reject an order.",
        "possibleVals": [
        true,
        false
        ]
    },
    orderFeedback:{
        "name": "orderFeedback",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "if it is true then order feedback is shown on one click order page.",
        "possibleVals": [
        true,
        false
        ]
    },
    stockValidation:{
        "name": "stockValidation",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Restrict order based on stock quantity",
        "possibleVals": [
        true,
        false
        ]
    },
    stockDisplay:{
        "name": "stockDisplay",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Visibility of stock available",
        "possibleVals": [
        true,
        false
        ]
    },
    orderRemarksVisibility:{
        "name": "orderRemarksVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Disclaimer at order summary section",
        "possibleVals": [
        true,
        false
        ]
    },
    orderTrackingStages:{
        "name": "orderTrackingStages",
        "type": "list",
        "value": [ ],
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Order tracking and its subfeatures",
        "possibleVals": []
    },
    distributorVisibility:{
        "name": "distributorVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Visibility of Distributor/Supplier details.",
        "possibleVals": [
        true,
        false
        ]
    },
    orderSummaryDisclaimer:{
        "name": "orderSummaryDisclaimer",
        "type": "list",
        "value": [""],
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "custom disclaimers in order summary page",
        "possibleVals": [
        "string[]"
        ]
    },
    orderIssues:{
        "name": "orderIssues",
        "type": "list",
        "value": [  ],
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "custom order issues in order invoice page. This is shown when there is less than 5 stars .",
        "possibleVals": [
        "string[]"
        ]
    },
    orderCompliment:{
        "name": "orderCompliment",
        "type": "list",
        "value": [ ],
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "custom order feedbacks in order invoice page. This is shown when there are 5 stars .",
        
        "possibleVals": [
        "string[]"
        ]
    },
    firstOrderBanner:{
        "name": "firstOrderBanner",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Pop up message after placing first order",
        "possibleVals": [
        true,
        false
        ]
    },
    displaySuggestedQty:{
        "name": "displaySuggestedQty",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To enable order feedback according to JNJ logic. Logic for jnj was if user order a SKU according to the suggested quantity then that particular SKU will be removed from the orderfeedback screen",
        "possibleVals": [
        true,
        false
        ]
    },
    orderSuggestedQty:{
        "name": "orderSuggestedQty",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Same as showNotOrderedSuggestedProduct",
        "possibleVals": [
        true,
        false
        ]
    },
    reOrder:{
        "name": "reOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/wiki/spaces/AUD/pages/257327231",
        "description": "if set to true, reorder button will appear on order tracking page & the user will be able to reorder the orders placed in the past.",
        "possibleVals": [
        true,
        false
        ]
    },
    orderCancellation:{
        "name": "orderCancellation",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Order cancellation option in the app",
        "possibleVals": [
        true,
        false
        ]
    },
    orderCancellationPeriod:{
        "name": "orderCancellationPeriod",
        "type": "number",
        "value": 0,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Order cancellation option in the app will have this much time availability to cancel the order",
        "possibleVals": [
        1,
        2
        ]
    },
    minOrderValidationMessage:{
        "name": "minOrderValidationMessage",
        "type": "string",
        "value":"",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "If user places order less than  minimum order then text appearing on popup comes from this config",
        "possibleVals": [
        "string"
        ]
    },
    orderTrackingDefaultRange:{
        "name": "orderTrackingDefaultRange",
        "type": "number",
        "value": 0,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "In orderTracking, fromDate is 2 months from today for retailer and for other designation it is today itself for normal orders by default. For saveOrder it is 15 days from today by default. Using this configuration we can set it n days from today where n is orderTrackingDefaultRange",
        "possibleVals": [
            1,
            "n"
        ]
    },
    displayExpiryProduct:{
        "name": "displayExpiryProduct",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },
    FOCProduct:{
        "name": "FOCProduct",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
        true,
        false
        ]
    },
    displayOrderBillingInformation:{
        "name": "displayOrderBillingInformation",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "It’ll show the new UI for order tracking page (Unnati specific). It’ll show the ordered data along with invoiced/billing data (no of quantities billed etc).",
        "possibleVals": [
        true,
        false
        ]
    },
    createOrderJsonFile:{
        "name": "createOrderJsonFile",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "It is for JNJ specific, it will create json file of order",
        "possibleVals": [
        true,
        false
        ]
    },
    stock:{
        "name": "stock",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To make uom visible.",
        "possibleVals": [
        true,
        false
        ]
    },
    showMissedSchemePopUp:{
        "name": "showMissedSchemePopUp",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To show missed scheme functionality in app.",
        "possibleVals": [
        true,
        false
        ]
    },
    missedPoPUpMargin:{
        "name": "missedPoPUpMargin",
        "type": "number",
        "value": 0,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "to get for how much qty or percent difference missed popUp should be shown.",
        "possibleVals": [ ]
    },
    schemeCalculation:{
        "name": "schemeCalculation",
        "type": "string",
        "value": "none",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            "server",
            "app",
            "none"
        ]
    },
    toUseStockFilterInProductsApi:{
        "name": "toUseStockFilterInProductsApi",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "To use stock filter in products api.",
        "possibleVals": [
        true,
        false
        ]
    },
    estimatedDeliveryDateVisibility:{
        "name": "estimatedDeliveryDateVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Visibility of estimated delivery date in order checkout details.",
        "possibleVals": [
        true,
        false
        ]
    },
    orderSubmitButtonLabel: {
        "name": "orderSubmitButtonLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            "string"
        ]
    },
    locationPopupOnOrder: {
        "name": "locationPopupOnOrder",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            true,
            false
        ]
    },
    orderTncVisibility: {
        "name": "orderTncVisibility",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            true,
            false
        ]
    },
    orderTncLink: {
        "name": "orderTncLink",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            "string"
        ]
    },
    orderConfirmationPopup: {
        "name": "orderConfirmationPopup",
        "type": "boolean",
        "value": true,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            true,
            false
        ]
    },


    // normalisedQtyVisibility:false,
    // billingInformationVisibility:false,
    // missedItemBasket:'',//later
    // orderTrackingInvoiceVisibility:false,
    // orderCancellationTimer:0,//in secs
    // cancelOrderInOrdertracking:false,
    // orderCancellationDisclaimer:'',
    // orderCancellationSummaryDisclaimer:'',
    // orderCancellationReasons:[],
    // orderCancellationPeriod:0,
    // orderDSIdVisibility:false,
    // showSupplierDropdown:false,
    // buyInSets:false,

    // orderCheckoutPtrLabel:'',
    // orderCheckoutUnitLabel:'',
    // orderCheckoutFinalAmountLabel:'',
    // orderCheckoutTotalAmountLabel:'',
    // pricingApi:false,
    // toUseSupplierFilterInApi:false,
    // skipOffersInProductApi:false,
    // offersTabVisibility:false,
    // offersTabLabel:'',
    // discountCouponVisibility:false,
    // retailerMarginVisibility:false,
    // showExternalRecommendations:false,
    // showFreeProductLabel:false,


    // creditInfoPopup:false,


    // amountCalculation:false,
    // orderInvoiceDisclaimer:[],
    // // minOrderVisibility:boolean,
    // showMissedSchemePopUp:false,
    // missedPoPUpMargin:10,
    // toUseStockFilterInProductsApi:false,


    // defaultOrderUOM:'',
    // orderFulfillmentTimeMessage:'',
    // orderFulfillmentTime:0,
    // schemeCalculation:'',
    // teleOrder: false,
    // remoteOrder: false,
    // visitOrder: false,
    // allProduct: false,
    // oneClickOrder: false,
    // mandatedAssortment: false,
    // orderSummaryDisclaimer:[],
    // skuDescriptionFormatter: '',
    // skuCodeVisibility: false,
    // ptrLabel: '',
    // mrpLabel: '',
    // schemeLabel: '',
    // suggestedQtyVisibility: false,
    // unitLabel: '',
    // unitVisibility: false,
    // autoUOMConversion: false,
    // multiUOMSelection: false,
    // packUnitLabel: '',
    // caseUnitLabel: '',
    // otherUnitLabel: '',
    // orderCalculationType: '',
    // volumeDisplayUnit: '',
    // orderUnitConversion: '',
    // displayPrice: false,
    // schemeImplement: false,
    // orderRemarksVisibility: false,
    // minOrderType: '',
    // minOrder: '',
    // minOrderVisibility: false,
    // minOrderValidation: false,
    // distributorVisibility: false,
    // PENDING: false,
    // CONFIRMED: false,
    // REJECTED: false,
    // BILLED: false,
    // "Order under process": false,
    // CANCELLED: false,
    // orderFeedback: false,
    // orderInvoiceFeedback1: '',
    // orderInvoiceFeedback2: '',
    // orderInvoiceFeedback3: '',
    // orderInvoiceFeedback4: '',
    // orderInvoiceDisclaimer1: '',
    // orderInvoiceDisclaimer2: '',
    // orderInvoiceDisclaimer3: '',
    // showFirstOrderBanner: false,
    // orderNotification: false,
    // editOrder: false,
    // editAndAddOrder: false,
    // orderApproval: false,
    // startValue: '',
    // sequenceLength: '',
    // prefix: '',
    // suffix: '',
    // stockVisibility: false,
    // stockValidation: false,
    // smsSharing: false,
    // fbmessangerSharing: false,
    // lineSharing: false,
    // whatsappSharing: false,
    // saveOrder:false,
    // OrderPo:false,
    // orderTrackingStages:[],
    // restrictOrderEditingForRoles:[],
    // allowOrderEditingtimeInterval:[],
    // orderApprovalForRetailer:false,
    // threeTwoProgram:false,
    // reOrder:false,
    // appOrderCancellation:false,
    // expiryProduct:false,
    // FOCProduct:false,
    // orderCancellation:false,
    // createJsonFile:false,
    // orderTaking:false,
    // minimumOrderTextTwo:'',
    // minOrderValidationText:'',
    // orderTrackingDefaultRange:'',
    // OrderCancellationTime:0,
    // orderCancellationTimeFrame:0,
    // orderPo:false,
    // onlineCart:false,
    // orderPoPdf:false,
    // visitOrderIndex:0,
    // displayrRetailerMargin:false,
    // maxAllowedDigitForOrder:0,
    // maxDiscountVisibility:false,
    // fullFilledByLabel: '',
    // stock:false,
    // orderIssues:[],
    // orderCompliment:[],
    // orderVsBilling:false,
    // timeWiseSequencing:false,
    // showNotOrderedSuggestedProduct:false,
    // notOrderedAccordingToSuggestion:false,
    // otpVerification: false,
    // catalogueSearch: false,
    // qrCodeScanner: false,
    
}